const styles = ({ breakpoints }) => ({
  logo: {
    composes: 'logo',
    height: '1.125rem',
    backgroundSize: 'contain',
    marginTop: '3rem',
    [breakpoints.xs]: {
      paddingBottom: 0,
    },
  },
});

export default styles;
